import { createLinks } from "common-frontend-components";
export const adminRoutes = {
    posts: '/',
    categories: '/categories',
    gallery: '/gallery',
    galleryCategory: '/gallery/:categoryId',
    contactsManagement: '/contactsManagement',
    landingPageHeaderConfig: '/landingPageHeaderConfig',
    productsManagement: '/productsManagement',
    galleriesManagement: '/galleriesManagement',
};
export const adminLinks = createLinks(adminRoutes);
//# sourceMappingURL=adminRoutes.js.map